import Project2 from "../../assets/batelian.jpg";
import Project3 from "../../assets/project-2.png";
import Project1 from "../../assets/batelian.jpg";
import Project4 from "../../assets/project-4.png";
// import Project5 from "../../assets/project-5.png";
import Project7 from "../../assets/lms.jpg";
import Project6 from "../../assets/efoy.jpg";
import Project8 from "../../assets/project-8.png";
import Project9 from "../../assets/BitTorrent-Architecture.png";
import Project10 from "../../assets/reverse-proxy.jpg";
import Project11 from "../../assets/merin.jpg";

export const projectsData = [
  {
    id: 1,
    image: Project11,
    title: "Merin",
    category: "WebSite",
    techStack: [
      "Next.js",
      "TailwindCSS",
      "MongoDB",
      "NextkAuth",
      "cloudinary",
      "Shadcn",
      "React Query",
      "Express", 
    ],
    description:
      "The purpose of this platform is to address the issue of advertising by providing users with the ability to discover new businesses, explore their products, stay informed about related events, and take advantage of sales discounts",
    url: "https://www.merinbd.com/",
    // github: "https://github.com/Danitilahun/Imaginify",
  },
  {
    id: 2,
    image: Project1,
    title: "Batelian",
    category: "WebSite",
    techStack: ["Next.js", "Express", "MongoDB", "Zustand", "Shadcn Ui", "Tailwind"],
    description:
      "This platform acts as a bridge, connecting leading companies with top remote developers for seamless collaboration and project success.",
    url: "https://www.batelian.com/",
    // github: "https://github.com/Danitilahun/AshamFrontEnd",
  },






  {
    id: 3,
    image: Project6,
    title: "Efoy Homes",
    category: "WebSite",
    techStack: ["Vue.js", "Tailwind","Pinia"],
    description:
      "i have been working on Laravel and Vue project which is property listing which helps people get house and related property",
    // github: "https://github.com/Danitilahun/omnifood",
    // url: "https://omnifood-flame.vercel.app/",
  },


  {
    id: 4,
    image: Project7,
    title: "Simple Learning Management System ",
    category: "WebSite",
    techStack: ["Next.js", "Shadcn Ui", "Tailwind"],
    description:
      "Teachers can easily create and customize courses, including multimedia content. and Students can securely purchase courses through seamless payment processing",
      
    github: "https://github.com/DawitMinale/lms_next.js-13",
    url: "https://learning-management-system-ten-kappa.vercel.app/search",
  },

  

  {
    id: 5,
    image: Project9,
    category: "Backend",
    title: "BitTorrent Client",
    description:
      "Efficient Golang BitTorrent client with concurrency, precise parsing, and resilient tracker communication. Scalable, fault-tolerant, and handles multiple transfers seamlessly.",
    github: "https://github.com/DawitMinale/Bit_Torrent",
    techStack: ["Golang", "BitTorrent", "Concurrency", "Channels"],
    url: "",
  },

  {
    id: 6,
    image: Project10,
    category: "Backend",
    title: "Proxy Server",
    description:
      "Efficient, lightweight, and configurable proxy server designed to enhance privacy, control network traffic, and enable secure internet access.",
    github: "https://github.com/DawitMinale/Proxy_Server",
    techStack: ["Golang", "Goroutine", "Channels", "TCP"],
    url: "",
  },


  // {
  //   id: 5,
  //   image: Project5,
  //   title: "E-Commerce Product Page",
  //   category: "WebSite",
  //   techStack: ["React", "Node", "Express", "MongoDB", "Redux", "JWT"],
  //   description:
  //     "An e-commerce product page where users can filter products based on category.",
  //   url: "https://e-commerce-product-page-filtering.vercel.app/",
  //   github: "https://github.com/Danitilahun/E-Commerce_Product_Page_Filtering",
  // },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "WebSite",
  },
  {
    name: "Mobile",
  },
  {
    name: "Backend",
  },
];
